/**
 * The DASH MP4 Protection Scheme schemeIdUri.
 *
 * @group DRM
 * @beta
 */
export const MP4_PROTECTION_SCHEME = 'urn:mpeg:dash:mp4protection:2011';
//# sourceMappingURL=MP4_PROTECTION_SCHEME.js.map